// Projects Configuration
// Update this file to modify your portfolio projects

import { SiReact, SiNodedotjs, SiMongodb, SiTypescript, SiTailwindcss } from 'react-icons/si';

export const projects = [
  {
    title: "Enterprise Mobile Banking App",
    description: "Led development of a secure Android banking application serving 500K+ users. Implemented biometric authentication, real-time transaction updates, and offline mode. Integrated with core banking systems using RESTful APIs. Achieved 4.5+ star rating on Play Store.",
    technologies: [
      { name: "React Native", icon: SiReact, color: "text-cyan-500" },
      { name: "Node.js", icon: SiNodedotjs, color: "text-green-600" },
      { name: "MongoDB", icon: SiMongodb, color: "text-green-600" }
    ],
    github: "https://github.com/tusharsingh1991",
    live: "#",
    image: "bg-gray-800 dark:bg-gray-700"
  },
  {
    title: "FinTech Payment Gateway",
    description: "Architected secure payment processing system at Panaesha Capital handling $1M+ monthly transactions. Built with TypeScript and Node.js, integrated multiple payment providers, implemented OAuth 2.0 security, and achieved 85% test coverage. Enhanced fraud detection reducing chargebacks by 40%.",
    technologies: [
      { name: "Node.js", icon: SiNodedotjs, color: "text-green-600" },
      { name: "TypeScript", icon: SiTypescript, color: "text-blue-600" },
      { name: "MongoDB", icon: SiMongodb, color: "text-green-600" }
    ],
    github: "https://github.com/tusharsingh1991",
    live: "#",
    image: "bg-gray-700 dark:bg-gray-800"
  },
  {
    title: "Real-time Collaboration Platform",
    description: "Developed Socket.io based real-time communication system handling 100K+ daily active users at Eeziklit. Built WebSocket architecture for instant messaging, live notifications, and presence tracking. Optimized database queries reducing latency by 40% and improved system scalability.",
    technologies: [
      { name: "Node.js", icon: SiNodedotjs, color: "text-green-600" },
      { name: "React", icon: SiReact, color: "text-cyan-500" },
      { name: "MongoDB", icon: SiMongodb, color: "text-green-600" }
    ],
    github: "https://github.com/tusharsingh1991",
    live: "#",
    image: "bg-gray-900 dark:bg-gray-600"
  },
  {
    title: "Android Healthcare Suite",
    description: "Created comprehensive Android healthcare applications during early career at NSS. Built patient management, appointment scheduling, and telemedicine features. Achieved 200K+ downloads across multiple healthcare apps. Implemented secure data sync and HIPAA-compliant storage solutions.",
    technologies: [
      { name: "React Native", icon: SiReact, color: "text-cyan-500" },
      { name: "Node.js", icon: SiNodedotjs, color: "text-green-600" },
      { name: "MongoDB", icon: SiMongodb, color: "text-green-600" }
    ],
    github: "https://github.com/tusharsingh1991",
    live: "#",
    image: "bg-gray-600 dark:bg-gray-900"
  },
  {
    title: "Enterprise Testing Platform",
    description: "Contributed to building QA automation platform at Testovation. Developed responsive web interfaces with React.js and Material-UI that increased user engagement by 35%. Implemented comprehensive testing suites with Jest. Collaborated with international teams across time zones.",
    technologies: [
      { name: "React", icon: SiReact, color: "text-cyan-500" },
      { name: "TypeScript", icon: SiTypescript, color: "text-blue-600" },
      { name: "Node.js", icon: SiNodedotjs, color: "text-green-600" }
    ],
    github: "https://github.com/tusharsingh1991",
    live: "#",
    image: "bg-gray-700 dark:bg-gray-800"
  },
  {
    title: "Cloud-Native E-Commerce Platform",
    description: "Currently leading development of scalable e-commerce solution at R Systems. Built on AWS with microservices architecture, handling 10K+ concurrent users. Implemented CI/CD pipelines, containerized deployment with Docker, and real-time inventory management. Mentoring team of 5 developers.",
    technologies: [
      { name: "React", icon: SiReact, color: "text-cyan-500" },
      { name: "Node.js", icon: SiNodedotjs, color: "text-green-600" },
      { name: "Tailwind", icon: SiTailwindcss, color: "text-teal-500" }
    ],
    github: "https://github.com/tusharsingh1991",
    live: "#",
    image: "bg-gray-800 dark:bg-gray-700"
  }
];

export default projects;
